import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectAuth, performLogout } from "../../../store/auth_slice";
import { useNavigate } from "react-router-dom";
import { AppDispatch } from "../../../store/store";
import ToastService from "../../../common/toast/toast_service";

interface DropdownProps {
  isOpen: boolean;
  openLoginModal: () => void;
  openSignUpModal: () => void;
}

const Dropdown: React.FC<DropdownProps> = ({
  isOpen,
  openLoginModal,
  openSignUpModal,
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { isAuthenticated } = useSelector(selectAuth);

  if (!isOpen) return null;

  const handleLogout = () => {
    dispatch(performLogout());
    ToastService.showSuccess("You have been successfully logged out.");
    navigate("/");
  };

  return (
    <div className="absolute right-0 mt-2 w-32 bg-white rounded-xl shadow-lg z-50 py-5 font-ubuntu text-sm">
      {isAuthenticated && (
        <>
          {/* <a
            href="/messages"
            className="block px-4 py-1 text-gray-800 hover:bg-gray-100"
          >
            Messages
          </a> */}
          {/* <a
            href="/my-orders"
            className="block px-4 py-1 text-gray-800 hover:bg-gray-100"
          >
            Orders
          </a> */}
          <a
            href="/account"
            className="block px-4 py-1 text-gray-800 hover:bg-gray-100"
          >
            My Account
          </a>
          <a href="/my-listings" className="block px-4 py-1 text-gray-800 hover:bg-gray-100">
            My Listings
          </a>
        </>
      )}

      {!isAuthenticated && (
        <>
          <button
            onClick={openLoginModal}
            className="block w-full text-left px-4 py-1 text-gray-800 hover:bg-gray-100"
          >
            Login
          </button>

          <button
            onClick={openSignUpModal}
            className="block w-full text-left px-4 py-1 text-gray-800 hover:bg-gray-100"
          >
            Sign up
          </button>
        </>
      )}

      {isAuthenticated && (
        <button
          onClick={handleLogout}
          className="block w-full text-left px-4 py-1 text-gray-800 hover:bg-gray-100"
        >
          Logout
        </button>
      )}
    </div>
  );
};

export default Dropdown;
